module.exports = __webpack_public_path__ + "static/media/office_fruit.96024c81.jpeg";